import React from 'react'
import { KILL_URLS } from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import CurrentShares from './CurrentShares'

const CurrentSharesContainer = (props: any): React.ReactNode => {
  const isFeatureEnabled = useFeatureEnabled(KILL_URLS)
  return <CurrentShares {...props} isFeatureEnabled={isFeatureEnabled} />
}

export default CurrentSharesContainer
